import type React from "react";

import { useAppSelector } from "../../store/reducer";

import NotificationPanel from "@helsenorge/designsystem-react/components/NotificationPanel";

import { OppgaveKanIkkeUtforesType } from "../../enums/oppgaveKanIkkeUtforesType";
import { useGetResources } from "../../hooks/useGetResources";

import styles from "../../styles/oppgave-detaljer.module.scss";

const KanIkkeUtfore = (): React.JSX.Element | null => {
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave!);
  const resources = useGetResources();

  if (oppgave?.KanInnloggetInnbyggerUtforeOppgave) {
    return null;
  }
  const visKanIkkeUrforesMelding = (): string | undefined => {
    switch (oppgave?.OppgaveKanIkkeUtfores) {
      case OppgaveKanIkkeUtforesType.OppgaveTilpassetKunInnbygger:
        return resources?.harIkkeTilgang_oppgave_kunInnbygger;
      case OppgaveKanIkkeUtforesType.OppgaveTilpassetIkkeFullmakt:
        return resources?.harIkkeTilgang_oppgave_kanIkkeFullmakt;
      case OppgaveKanIkkeUtforesType.OppgaveTilpassetIkkePaVegnAvBarn:
        return resources?.harIkkeTilgang_oppgave_paVegnAvBarn;
      case OppgaveKanIkkeUtforesType.OppgaveTilpassetIkkePaVegnAvBarnUnder12:
        return resources?.harIkkeTilgang_oppgave_paVegnAvBarnUnder12;
      case OppgaveKanIkkeUtforesType.OppgaveTilpassetIkkePaVegnAvBarnMellom12Og16:
        return resources?.harIkkeTilgang_oppgave_paVegnAvBarnMellom12Og16;
      case OppgaveKanIkkeUtforesType.SperretAdresse:
        return resources?.harIkkeTilgang_sperretadresse;
      case OppgaveKanIkkeUtforesType.Ungdom:
        return resources?.harIkkeTilgang_ungdom;
      default:
        return resources?.feilmelding_kanIkkeUtforeOppgave;
    }
  };

  return (
    <div className={styles.detaljer_seksjon}>
      <NotificationPanel
        testId="kanIkkeUtforeOppgave"
        variant="warn"
        className={styles.notificationpanel}
      >
        {visKanIkkeUrforesMelding()}
      </NotificationPanel>
    </div>
  );
};

export default KanIkkeUtfore;
